/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Deutsch_Lernen24Inputs */

const en__field_enum_csjensblank_deutsch_lernen24 = /** @type {(inputs: _Field_Enum_Csjensblank_Deutsch_Lernen24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`improve your proficiency in german`)
};

const de__field_enum_csjensblank_deutsch_lernen24 = /** @type {(inputs: _Field_Enum_Csjensblank_Deutsch_Lernen24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch lernen/ verbessern`)
};

/**
* | output |
* | --- |
* | "improve your proficiency in german" |
*
* @param {_Field_Enum_Csjensblank_Deutsch_Lernen24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_deutsch_lernen24 = /** @type {((inputs?: _Field_Enum_Csjensblank_Deutsch_Lernen24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Deutsch_Lernen24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_deutsch_lernen24(inputs)
	return de__field_enum_csjensblank_deutsch_lernen24(inputs)
});
export { _field_enum_csjensblank_deutsch_lernen24 as "_field_enum_CSJENSBLANK_DEUTSCH_LERNEN" }